import React, { useEffect, useState } from "react";
import SettingContainer from "../SettingContainer";
import ActivityLoader from "../../Common/ActivityLoader";
import Notification from "../../Common/Notification";
import { useTheme } from "../../../DataStore/ThemeContext";
import ajaxConfig from "../../../util/remote/ajaxConfig";
import functions from "../../../util/functions";
import { useConfig } from "../../../DataStore/ConfigContext";

const KeyConfig = () => {
  const { setNotify, openSettings } = useTheme();
  const { showNewKeyModal, dispatch } = useConfig();
  
  const [keys, setKeys] = useState(null);

  useEffect(() => {
    getKeys();
  }, []);

  const handleRefresh = () => {
    getKeys();
  };

  const getKeys = async () => {
    let server_response = await ajaxConfig.fetchKeys();
    if (server_response.status === "OK") {
      setKeys(server_response.details);
    } else {
      setNotify(
        <Notification
          message={server_response.message}
          type="danger"
          closable={false}
        />
      );
      setKeys("404");
    }
  };

  const truncateText = (text, maxLength) => {
    if (!text) return '';
    if (text.length > maxLength) {
      return (
        <span title={text}>
          {text.substring(0, maxLength)}...
        </span>
      );
    }
    return text;
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        setNotify(
          <Notification message="Key copied to clipboard!" type="success" />
        );
      })
      .catch(() => {
        setNotify(
          <Notification message="Failed to copy key." type="danger" />
        );
      });
  };

  const menu = () => (
    <>
      <button
        type="button"
        tabIndex="0"
        className="dropdown-item"
        onClick={handleNew}
      >
        <i className="dropdown-icon fa fa-plus"> </i>
        <span>New Key</span>
      </button>
      <button
        type="button"
        tabIndex="0"
        className="dropdown-item"
        onClick={handleRefresh}
      >
        <i className="dropdown-icon fa fa-refresh"> </i>
        <span>Refresh</span>
      </button>
    </>
  );

  const handleNew = (record) => {
    dispatch({ type: "showNewKeyModal", payload: true });
  };

  return (
    <SettingContainer title="System Keys" icon="fa fa-key" Menu={menu}>
      <div className="table-responsive">
        <table className="table table-striped">
          <thead className="thead-light">
            <tr>
              <th>#</th>
              <th>Username</th>
              <th>Description</th>
              <th>Key</th>
              <th>Date Created</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(keys) && keys.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.username}</td>
                <td>{item.description}</td>
                <td>
                  <span className="d-inline-flex align-items-center">
                    {truncateText(item.key_value, 15)}
                    <button
                      className="btn btn-link btn-sm ml-2"
                      title="Copy Key"
                      onClick={() => handleCopy(item.key_value)}
                    >
                      <i className="fa fa-copy"></i>
                    </button>
                  </span>
                </td>
                <td>{functions.formatDate(item.created_at)}</td>
                <td>
                  <button className="btn btn-outline-danger btn-sm">
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {!keys && <ActivityLoader />}
      {keys === "404" && (
        <Notification type="light" message="No system key found." />
      )}
    </SettingContainer>
  );
};

export default KeyConfig;
